module.exports = __webpack_public_path__ + "static/media/logoForeign.1f1a195a.svg";